import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';
import { useNavigate } from '@tanstack/react-router';
import type { paths } from '@bet99-pickem/api-types';

type UpdatePickemRequest =
  paths['/api/admin/pickems/{id}']['put']['requestBody']['content']['application/json'];

interface UpdatePickemDto extends UpdatePickemRequest {
  id: string;
}

export const updatePickem = ({ id, ...data }: UpdatePickemDto) =>
  api.put(apiEndpoints.updatePickem(id), data);

export const useUpdatePickemMutation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: updatePickem,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.all });
      toast.success('Pickem updated successfully');
      navigate({ to: '/dashboard/pickems' });
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to update pickem');
    },
  });
};
